import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconZoomIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"zoom-in,search-plus"} maskId="square-filled-radius-0-stroke-1-IconZoomIn"><path fillRule="evenodd" clipRule="evenodd" d="M3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 13.029 18.2447 14.8815 16.9999 16.2918L20.958 20.2499L20.2509 20.957L16.2928 16.999C14.8824 18.2443 13.0295 19 11 19C6.58172 19 3 15.4183 3 11ZM11.5 10.5V7.5H10.5V10.5H7.5V11.5H10.5V14.5H11.5V11.5H14.5V10.5H11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconZoomIn;
